module.exports = "/_next/static/images/folder-122d6a614d78bfa8ef02e866e4214eac.svg";